



import mitt from 'mitt';



type Events = {
  'forgot-password-clicked': void;
  'forgot-password-email-link-sent': string;
  'forgot-password-email-link-received': string;
  'forgot-password-email-link-verified': void;
  'forgot-password-password-reset-successfull': void;
  'open-forgot-password-enter-email-dialog': void;
};



const forgotPasswordEvents = mitt<Events>();

export default forgotPasswordEvents;